let PackagesItem = [
    {
        trackTitle: "FULL Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "500",
        // trackFullPrice: '500',
        trackJunior: true,
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1665755318247x161791341025034240',
        // earlyBird: true,
    },
    {
        trackTitle: "Junior Track",
        trackJunior: true,
        trackSubtitle: "For Junior specialists",
        trackPrice: "0",
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticketfree/1665755104939x792882970716012500',
        // earlyBird: true,
    },
    {
        trackTitle: "2 QA Events",
        event1: "QA Global Summit'23",
        event2: "AI in QA and Testing'23",
        event2Link: "https://events.geekle.us/aitesting/",
        trackPrice: "599",
        trackFullPrice: '1000',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: '2 Live events + Recordings',
        trackLink: 'https://geekle.us/ticket/1682337096583x502102151772766200',
    },
    {
        trackTitle: "Year of QA",
        year: "One year program with Four Full Access Tickets on 4 QA conferences",
        trackPrice: "649",
        trackFullPrice: '1200',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1683107393633x783660260263198700',
    },
];

export default PackagesItem;
